import page from './Cert.vue';
export default page;



// WEBPACK FOOTER //
// ./src/pages/cert/index.js